var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightingService(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 108,
    viewBox: "0 0 108 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_609_24)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 50,
    r: 50,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.1654 79.1666H59.832M42.332 58.7499H65.6654M33.582 41.2499C33.582 35.8351 35.7331 30.642 39.5619 26.8132C43.3908 22.9843 48.5839 20.8333 53.9987 20.8333C59.4135 20.8333 64.6066 22.9843 68.4355 26.8132C72.2643 30.642 74.4154 35.8351 74.4154 41.2499C74.4173 44.5372 73.6222 47.776 72.0983 50.6887C70.5744 53.6014 68.367 56.1013 65.6654 57.9741L64.0845 65.4582C63.8752 66.8377 63.1784 68.0965 62.1205 69.0062C61.0625 69.916 59.7136 70.4163 58.3183 70.4166H49.6791C48.2838 70.4163 46.9349 69.916 45.8769 69.0062C44.819 68.0965 44.1222 66.8377 43.9129 65.4582L42.332 58.0062C39.6295 56.1267 37.422 53.621 35.8983 50.7031C34.3746 47.7852 33.5799 44.5417 33.582 41.2499Z",
    stroke: "#5f9098",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_609_24",
    x: 0,
    y: 0,
    width: 108,
    height: 108,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0.372549 0 0 0 0 0.564706 0 0 0 0 0.596078 0 0 0 1 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.372549 0 0 0 0 0.564706 0 0 0 0 0.596078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_609_24"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_609_24",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightingService);
export default __webpack_public_path__ + "static/media/LightingService.1cd0d1149bfc3357fe645fe2dbc3323e.svg";
export { ForwardRef as ReactComponent };